import { useTranslation } from 'react-i18next';

const ContactSection = () => {
  const { t } = useTranslation('pharmacies');

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            {t('cta.subtitle')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
              {t('cta.primaryButton')}
            </button>
            <button className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
              {t('cta.secondaryButton')}
            </button>
          </div>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Llámenos</h3>
              <p className="text-gray-600">Hable directamente con nuestros expertos en farmacias</p>
              <p className="text-blue-600 font-semibold mt-2">(555) 123-4567</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Envíenos un Email</h3>
              <p className="text-gray-600">Obtenga respuestas a sus preguntas sobre servicios</p>
              <p className="text-blue-600 font-semibold mt-2">pharmacy@ledgrkeeper.com</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Programe una Reunión</h3>
              <p className="text-gray-600">Reserve una consulta gratuita de 30 minutos</p>
              <button className="text-blue-600 font-semibold mt-2 hover:underline cursor-pointer">
                Ver Disponibilidad
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;